import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, SessionInformation } from '@frontend-site/shared/data';
import { map, Observable } from 'rxjs';

const PQM = '/pqm';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    constructor(@Inject(API_URL) private readonly apiUrl: string, private readonly http: HttpClient) {}

    getUsername(): Observable<string> {
        return this.http.get<{ result: string }>(`${this.apiUrl}/general/username`).pipe(map((data) => data.result));
    }

    getSessionInformation(companyId?: number): Observable<SessionInformation> {
        return this.http.get<SessionInformation>(`${this.apiUrl}${PQM}/sessionInformation${companyId ? `/${companyId}` : ''}`);
    }
}
